import React from 'react';
import { Collapse } from 'react-bootstrap';
import CheckboxInput from 'shared/components/CheckboxInput';

const NeedArray = (props) => {
  const {
    name,
    onChangeParameter,
    parameters,
    children,
    groupName,
    disabled
  } = props;

  const checked = parameters && parameters.has_array === '1';

  const onChange = (e) => onChangeParameter(name, e.target.checked ? '1' : '0');

  return (
    <div>
      <div className="panel panel-default mb-3">
        <div className="panel-heading">
          <div className="panel-title m-0">
            <label htmlFor={name} className="advanced-specs-link m-0">
              <CheckboxInput
                disabled={disabled}
                inputClassName="mr-2"
                inputId={name}
                name={name}
                groupName={groupName}
                checked={checked}
                onChange={onChange} />
              {Spree.translations.need_array_question}
            </label>
          </div>
        </div>
      </div>

      <Collapse in={checked}>
        {children}
      </Collapse>
    </div>
  );
};


NeedArray.defaultProps = {
  name: 'has_array',
  groupName: 'parameters',
};

export default NeedArray;